import React from "react";
import {
  ComplianceCaseStatus,
  ComplianceCaseSubStatus,
  ComplianceCaseTypeEnum,
} from "~/graphql/supergraphEnums";
import { ProgramName } from "../../utils/constants";
import { PositionsTableRowItem } from "../types";
import LegacyKycStatus from "./LegacyKycStatus";
import PositionCaseStatus from "./PositionCaseStatus";
import RemediationInvite from "./RemediationInvite";
import RemediationRequired from "./RemediationRequired";
import StatusWithLink from "./StatusWithLink";

interface Props {
  data: PositionsTableRowItem;
}

const OnboardingCellRenderer: React.FC<Props> = ({ data }) => {
  if (data.isLegacyKyc) {
    return <LegacyKycStatus />;
  }

  const onboardingDetails = data.onboardingStatus;
  if (!onboardingDetails) {
    return <RemediationRequired data={data} />;
  }
  const { caseType, status, subStatus, complianceInvitation } = onboardingDetails;

  if (
    caseType === ComplianceCaseTypeEnum.Remediation &&
    status === ComplianceCaseStatus.NotReady
  ) {
    if (subStatus === null && complianceInvitation) {
      return (
        <RemediationInvite
          positionId={data.id}
          arenaId={data.client?.id || ""}
          entityId={data.entity?.id || ""}
          programName={(data.program?.[0] as ProgramName) || "AML (US)"}
          positionName={data.position?.accountName || ""}
          entityName={data.entity?.name || ""}
          portalStatus={data.position?.portalStatus || null}
          complianceInvitation={complianceInvitation}
        />
      );
    } else if (subStatus === ComplianceCaseSubStatus.PendingSubmission) {
      return (
        <StatusWithLink
          label="LP request in progress"
          urlToLaunch={`/canopy/compliance/case/${onboardingDetails.id}`}
          hoverTooltip="View case"
        />
      );
    }
    // For any other state we will fall through to the PositionCaseStatus
  }

  return (
    <PositionCaseStatus
      caseDetails={onboardingDetails}
      id={data.id}
      prospectId={data.prospectId}
      subscriptionId={data.subscriptionId}
    />
  );
};

export default OnboardingCellRenderer;
